import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=1298355e&scoped=true&lang=html&"
import script from "./depositList.vue?vue&type=script&lang=js&"
export * from "./depositList.vue?vue&type=script&lang=js&"
import style0 from "./depositList.vue?vue&type=style&index=0&id=1298355e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298355e",
  null
  
)

export default component.exports